import {
  getBooleanSchema,
  getEmailSchema,
  getNullableIntegerSchema,
  getSelectSchema,
  getStringSchema,
} from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const EmployeeSchema = Yup.object().shape({
  userId: getSelectSchema('User').notRequired(),
  shortName: getStringSchema(50, 'Short name'),
  branchId: getSelectSchema('Branch'),
  managerEmployeeId: getSelectSchema('Manager').notRequired(),
  docusignUser: getStringSchema(50, 'Docusign User').notRequired(),
  sceEntryCCEmail: getEmailSchema('SCE CC').notRequired(),
  payrollEmpNbr: getNullableIntegerSchema('Payroll Key (Emp#)')
    .transform((value, originalValue) => {
      if (originalValue === null || originalValue === undefined || originalValue === '') return 0;
      return value;
    })
    .default(0),
  isRiskManager: getBooleanSchema('Is Risk Manager?'),
  isSalesOrOther: getBooleanSchema('Is Sales/Other?'),
  isLRPProcessor: getBooleanSchema('Is LRP Processor?'),
  isActive: getBooleanSchema('Active', true),
});
